// extracted by mini-css-extract-plugin
module.exports = {"loadingDisplay":"LoadingDisplay_loadingDisplay__2pLZt","imageContainer":"LoadingDisplay_imageContainer__3U3xo"};